"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_infinite_scroller_1 = __importDefault(require("react-infinite-scroller"));
var withPagination_1 = require("../hocs/withPagination");
var Loading_1 = __importDefault(require("./Loading"));
var PaginatedInfiniteScroll = function (_a) {
    var children = _a.children, _b = _a.loader, loader = _b === void 0 ? false : _b, _c = _a.useWindow, useWindow = _c === void 0 ? true : _c;
    var _d = (0, withPagination_1.usePaginationContext)(), metadata = _d.metadata, loading = _d.loading, getAfter = _d.getAfter;
    return (react_1.default.createElement(react_infinite_scroller_1.default, { hasMore: metadata.has_more, loadMore: function () {
            if (!loading) {
                getAfter();
            }
        }, threshold: 1000, loader: loader ? react_1.default.createElement(Loading_1.default, null) : undefined, useWindow: useWindow }, children));
};
exports.default = PaginatedInfiniteScroll;
//# sourceMappingURL=PaginatedInfiniteScroll.js.map